import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ExpenseForm = _resolveComponent("ExpenseForm")
  const _component_ExpenseFormProvider = _resolveComponent("ExpenseFormProvider")
  const _component_Slideover = _resolveComponent("Slideover")

  return (_openBlock(), _createBlock(_component_Slideover, {
    show: _ctx.show,
    "set-close": _ctx.setClose,
    onClose: _cache[2] || (_cache[2] = $event => (_ctx.closeModal($event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ExpenseFormProvider, {
        data: _ctx.data,
        "edit-mode": _ctx.editMode,
        type: _ctx.type,
        "hide-sidebar": _ctx.hideSidebar,
        "onClose-modal": _cache[1] || (_cache[1] = $event => (_ctx.setCloseModal($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ExpenseForm)
        ]),
        _: 1
      }, 8, ["data", "edit-mode", "type", "hide-sidebar"])
    ]),
    _: 1
  }, 8, ["show", "set-close"]))
}